module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_label":"New label","label_name":"Label name","label_color":"Label color","label_placeholder":"Write label name here"},"id":{"new_label":"Label baru","label_name":"Nama label","label_color":"Warna label","label_placeholder":"Tulis nama label di sini"}}')
  delete Component.options._Ctor
}
